enum SelectingTimes {
  Hour = 1,
  Minute = 2,
  Second = 3
}

export { SelectingTimes }



// WEBPACK FOOTER //
// ../../../src/components/VTimePicker/SelectingTimes.ts